import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'stx-reports',
  templateUrl: './reports.component.html',
  styleUrls: [],
  imports: [RouterOutlet]
})
export class ReportsComponent {}
